export default "__VITE_ASSET__70ad121f__"